'use client';

import Link from 'next/link';
import { cn } from '@/libs';
interface IButton {
  href: string;
  text: string;
  className?: string;
  disabled?: boolean;
}
export const Button: React.FC<IButton> = ({
  href,
  text,
  className,
  disabled
}) => {
  return <Link href={{
    pathname: href
  }} className={cn(disabled && 'pointer-events-none')}>
      <button className={cn('rounded-lg bg-gradient-to-r from-primary to-secondary px-5 py-1 font-bold text-white', className)}>
        {text}
      </button>
    </Link>;
};